import { createFileRoute } from '@tanstack/react-router'
import { CasesList } from 'pages/cases/CasesList'
import { caseListSearchParams } from 'routes/cases/-searchParams'

const RouteComponent = () => {
  const { siteId } = Route.useSearch()

  return <CasesList siteID={siteId} />
}

export const Route = createFileRoute('/cases/')({
  component: RouteComponent,
  validateSearch: caseListSearchParams,
  staticData: {
    title: 'Cases',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: false,
    },
  },
})
